export enum CategoryEnum{
    DENIM = 'Denim',
    NON_DENIM='Non denim'   
  }
  export const CategoryEnumDisplay = [
    { name: "DENIM", displayVal:'Denim'},
    { name:'NON_DENIM', displayVal:'Non denim'},
]